/* unplugin-vue-components disabled */import script from "./QoQ.vue?vue&type=script&setup=true&lang=js"
export * from "./QoQ.vue?vue&type=script&setup=true&lang=js"

import "./QoQ.vue?vue&type=style&index=0&id=75f1c4fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f1c4fe"]])

export default __exports__